import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ClubDetailsComponent from "../../components/ClubDetailsComponent";
import { FaArrowLeft } from "react-icons/fa6";
import SuggestedFollows from "../../components/SuggestedFollow";
import LatestNews from "../../components/LatestNews";
import Nav from 'react-bootstrap/Nav';
import PostList from "../../components/Post";
import MemberList from "../../components/ClubMembers";


function ClubDetails() {
  const [activeTab, setActiveTab] = useState("option1"); // Default tab
  const location = useLocation();
  const navigate = useNavigate();
  // Retrieve club data from state
  const club = location.state?.club;

  // If no club data is found, show an error message
  if (!club) {
    return <h2>Club Not Found</h2>;
  }

  return (
    <div className="club-details">
      <div className="club-post-section">
        {/* Back Button */}
        <div className="back-button" onClick={() => navigate(-1)}>
          <span><FaArrowLeft className="back-icon" /></span> <h2>Clubs</h2>
        </div>
        {/* Club Details */}
        <ClubDetailsComponent />
        {/* Navigation Tabs */}
        <Nav variant="pills" activeKey={activeTab} onSelect={(selectedKey) => setActiveTab(selectedKey)}>
          <Nav.Item>
            <Nav.Link eventKey="option1">Posts & Polls</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="option2">Members</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="option3">Events</Nav.Link>
          </Nav.Item>
        </Nav>

        {/* Tab Content */}
        <div className="tab-content mt-3">
          {activeTab === "option1" && <div>
            <PostList filterByType={["post", "poll"]} />
          </div>}
          {activeTab === "option2" && <div>
            <MemberList/>
          </div>}
          {activeTab === "option3" && <div>
            <PostList filterByType="event" />
          </div>}
        </div>
      </div>
      <div className="right-side-bar">
        <LatestNews />
        <SuggestedFollows />
      </div>
    </div>
  );
};

export default ClubDetails;


